import { FaServer, FaReact, FaDatabase, FaLock, FaPlug, FaSitemap } from "react-icons/fa";
import { SiNestjs, SiAmazonaws } from "react-icons/si";

export const featuresData = [
  {
    id: 1,
    icon: <SiNestjs />,
    title: "Backend & REST API Development",
    des: "Build modular NestJS and Node.js APIs with clean architecture, versioning, and production-ready error handling across enterprise domains.",
  },
  {
    id: 2,
    icon: <FaSitemap />,
    title: "Multi-tenant Architecture",
    des: "Design multi-tenant database systems with strict data isolation using NestJS middleware and Prisma ORM for fintech and SaaS workloads.",
  },
  {
    id: 3,
    icon: <FaServer />,
    title: "Real-time Systems",
    des: "Deliver WebSocket and SSE-based real-time features — including compliance engines and live data sync — operating below 200ms latency.",
  },
  {
    id: 4,
    icon: <FaReact />,
    title: "Full Stack Frontend Delivery",
    des: "Ship responsive React.js UIs with TypeScript, Redux Toolkit, Zustand, and Tailwind CSS focused on reusable components and UX.",
  },
  {
    id: 5,
    icon: <FaDatabase />,
    title: "Database Design & Performance",
    des: "Model and optimize PostgreSQL, MongoDB, Redis, and SQLite with Prisma — indexed queries improving API response times by up to 25%.",
  },
  {
    id: 6,
    icon: <FaPlug />,
    title: "Payment & Third-Party Integrations",
    des: "Integrate production APIs including Sportradar, PayPal, Trustly, Mercoa, Razorpay, WhatsApp Business API, and AWS S3.",
  },
  {
    id: 7,
    icon: <FaLock />,
    title: "Auth & Security",
    des: "Implement JWT, RBAC, bcrypt, and OAuth2 flows that cut authentication-related support issues by ~30% in production.",
  },
  {
    id: 8,
    icon: <SiAmazonaws />,
    title: "Cloud Deployment & DevOps",
    des: "Deploy and operate apps on AWS EC2 with PM2, Nginx, Docker, S3, and CI/CD via GitHub Actions for reliable uptime.",
  },
];
